import PropTypes from 'prop-types'

/**
 * @typedef {Object} objectPrivateUseModesPropType
 * Defines the configuration for an object for logbook private use mode
 *
 * @property {String} logbookMode             - Logbook Mode configured.
 * @property {number} objectId                - Object to which applies this config
 * @property {number} objectLogBookPrivacyId  - Id of record in database
 */
const objectPrivateUseModesPropType = PropTypes.shape({
    logbookMode: PropTypes.string.isRequired,
    objectId: PropTypes.number.isRequired,
    objectLogBookPrivacyId: PropTypes.number.isRequired
})

export { objectPrivateUseModesPropType }
